import i18n from '@/utils/i18n';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

const ACCOUNT_SELECTOR_WIDTH = 240;
const GUIDE_SELECTOR_WIDTH = 140;
const SELECTOR_HEIGHT = 32;

/**
 * Loading placeholders for the header's account + order guide selectors,
 * rendered in the same header slot as the real controls.
 */
export const OrderGuideSelectorsSkeleton = () => {
  const [styles, theme] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t('sales_portal.order_guides_list.title')}
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      style={styles.container}
    >
      <AnimatedSkeletonLoader
        borderRadius={theme.sk.radii.radiusMedium}
        height={SELECTOR_HEIGHT}
        width={ACCOUNT_SELECTOR_WIDTH}
      />
      <AnimatedSkeletonLoader
        borderRadius={theme.sk.radii.radiusMedium}
        height={SELECTOR_HEIGHT}
        width={GUIDE_SELECTOR_WIDTH}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
  },
}));
